export default function ( callback, timeout = 100 ) {
	var wait = false;
	return function () {
		if (!wait) {
			callback.call();
			wait = true;
			setTimeout(function () {
				wait = false;
			}, timeout);
		}
	}
}